/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-hide-min-max',
  templateUrl: './widget-layers-hide-min-max.component.html',
  styleUrls: ['./widget-layers-hide-min-max.component.css']
})
export class WidgetLayersHideMinMaxComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: boolean) {
    this.widgetLayers.layer(this.current).change({ gaugeHideMinMax: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeHideMinMax: value }, this.current);
  }

}
